<div class="side-menu" role="navigation">
    @if (menu && menu.breadcrumb && menu.breadcrumb.label) {
        <nw-side-menu-breadcrumb
            tabindex="100"
            data-testid="side-menu__breadcrumb"
            [label]="menu.breadcrumb.label"
            (keydown.enter)="menu.breadcrumb.onClick()"
            (keydown.space)="menu.breadcrumb.onClick()"
            (mousedown)="menu.breadcrumb.onClick()"
        ></nw-side-menu-breadcrumb>
    }
    <div role="list">
        <ng-template #recursiveList let-items let-visible="visible">
            @for (item of items; track item) {
                @if (item.isCta) {
                    <nw-side-menu-call-to-action
                        class="side-menu__list__call-to-action"
                        role="listitem"
                        [attr.tabindex]="visible ? item.id : undefined"
                        [label]="item.label"
                        (keydown.enter)="emit($event, item)"
                        (click)="emit($event, item)"
                        [nwAddAttributes]="item.attributes"
                    ></nw-side-menu-call-to-action>
                } @else if (item.items) {
                    <nw-side-menu-parent
                        role="listitem"
                        [attr.tabindex]="visible ? item.id : undefined"
                        [label]="item.label"
                        [badge]="item.badge"
                        [active]="item.active"
                        [open]="item.open"
                        [parentId]="item.parentId"
                        (keydown.enter)="clickParent($event, item)"
                        (click)="clickParent($event, item)"
                        [nwAddAttributes]="item.attributes"
                    ></nw-side-menu-parent>
                } @else {
                    <nw-side-menu-child
                        role="listitem"
                        [attr.tabindex]="!item.path && visible ? item.id : undefined"
                        [linkTabIndex]="visible ? item.id : undefined"
                        [label]="item.label"
                        [path]="item.path"
                        [badge]="item.badge"
                        [active]="item.active"
                        [isGrandChild]="item.parentId | isGrandChild: menu"
                        [isOrphan]="!item.parentId"
                        [dynamic]="item.dynamic"
                        (keydown.enter)="!item.path && emit($event, item)"
                        (click)="emit($event, item)"
                        [nwAddAttributes]="item.attributes"
                    ></nw-side-menu-child>
                }
                @if (item.items?.length > 0 && item.open) {
                    <div class="side-menu__list">
                        <ng-container
                            *ngTemplateOutlet="
                                recursiveList;
                                context: { $implicit: item.items, visible: item.open }
                            "
                        ></ng-container>
                    </div>
                }
            }
        </ng-template>
        <ng-container
            *ngTemplateOutlet="
                recursiveList;
                context: { $implicit: menu?.items, visible: true }
            "
        ></ng-container>
    </div>
    <ng-content></ng-content>
</div>
